module.exports = __webpack_public_path__ + "static/media/wren.5bf9a1e9.png";